import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {doc, getDoc, addDoc, setDoc, collection, deleteDoc} from "firebase/firestore";
import {Firestore} from "../../../utils/Firebase";
import * as React from "react";
import {DashboardMenuContainer} from "../Dashboard/DashboardMenu";
import {Button, Container, Grid, TextField} from "@mui/material";
import "../Shelters/sheltersStyle.css";


const Shelter = () => {
    const [shelterData, setShelterData] = useState({
        capacity: "",
        city: "",
        contact: "",
        images: [],
        locationSrc: "",
        name: "",
        openingHours: {from: "", to: ""},
        priceList: [],
        rules: [],
        services: [],
        street: "",
        usedCapacity: ""
    });

    const navigate = useNavigate();
    const {id} = useParams();

    useEffect(() => {
        getDoc(doc(Firestore, "shelters", id))
            .then(d => {
                if (d.exists()) {
                    setShelterData(d.data());
                }
            })
            .catch(e => {
                console.error(e);
            });

    }, [id]);

    const handleInputChange = (event) => {
        const target = event.target;
        let value = target.type === 'checkbox' ? target.checked : target.value;
        if (target.type === "number") {
            value = parseFloat(value);
        }
        const name = target.name;
        console.log(shelterData);
        setShelterData({
            ...shelterData,
            [name]: value
        });
    }

    const handleArrayChange = (event) => {
        const name = event.target.name;
        const arrayName = name.split('-')[0];
        const index = name.split('-')[1];
        const arrayCopy = [...shelterData[arrayName]];
        arrayCopy[index] = event.target.value;

        setShelterData({
            ...shelterData,
            [arrayName]: arrayCopy
        });
    }

    const handleArrayObjectChange = (event) => {
        const name = event.target.name;
        const arrayName = name.split('-')[0];
        const index = name.split('-')[1];
        const objectKey = name.split('-')[2];

        let value = event.target.value;
        if (event.target.type === "number") {
            value = parseFloat(value);
        }

        const arrayCopy = [...shelterData[arrayName]];
        arrayCopy[index] = {
            ...arrayCopy[index],
            [objectKey]: value
        }

        setShelterData({
            ...shelterData,
            [arrayName]: arrayCopy
        });
    }

    const addToArray = (arrayName) => {
        setShelterData({
            ...shelterData,
            [arrayName]: [...shelterData[arrayName], ""]
        });
    }

    const popFromArray = (arrayName) => {
        setShelterData({
            ...shelterData,
            [arrayName]: shelterData[arrayName].slice(0, -1)
        });
    }

    const sendFormData = (e) => {
        e.preventDefault();
        if (id !== "new") {
            setDoc(doc(Firestore, "shelters", id), shelterData)
                .then(doc => {
                    navigate('/shelters');
                });
        }
        else {
            addDoc(collection(Firestore, "shelters"), shelterData)
                .then(doc => {
                    navigate('/shelters');
                });
        }
    }

    const deleteThisDoc = () => {
        deleteDoc(doc(Firestore, "shelters", id))
            .then(doc => {
                navigate('/shelters');
            });
    }

    return (
        DashboardMenuContainer(
            <Container maxWidth="md">
                <h1>Úprava nocľahárni</h1>
                <form onSubmit={sendFormData}>
                    <Grid container spacing={4}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                required
                                id="name"
                                name="name"
                                label="Názov zariadenia"
                                value={shelterData.name}
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                required
                                id="city"
                                name="city"
                                label="Mesto"
                                value={shelterData.city}
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                required
                                id="street"
                                name="street"
                                label="Ulica"
                                value={shelterData.street}
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                required
                                id="contact"
                                name="contact"
                                label="Telefónne číslo"
                                value={shelterData.contact}
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                required
                                id="locationSrc"
                                name="locationSrc"
                                label="Link na mapu"
                                value={shelterData.locationSrc}
                                onChange={handleInputChange}
                            />
                        </Grid>

                        <Grid item xs={6} sm={3}>
                            <TextField
                                fullWidth
                                required
                                id="openingHours.from"
                                name="openingHours.from"
                                label="Od"
                                value={shelterData.openingHours.from}
                                helperText="Otváracie hodiny"
                                onChange={(event) => {
                                    const target = event.target;
                                    setShelterData({
                                        ...shelterData,
                                        openingHours: {
                                            ...shelterData.openingHours,
                                            from: target.value
                                        }
                                    });
                                }}
                            />
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <TextField
                                fullWidth
                                required
                                id="openingHours.to"
                                name="openingHours.to"
                                label="Do"
                                value={shelterData.openingHours.to}
                                helperText="Otváracie hodiny"
                                onChange={(event) => {
                                    const target = event.target;
                                    setShelterData({
                                        ...shelterData,
                                        openingHours: {
                                            ...shelterData.openingHours,
                                            to: target.value
                                        }
                                    });
                                }}
                            />
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <TextField
                                fullWidth
                                required
                                type="number"
                                id="usedCapacity"
                                name="usedCapacity"
                                label="Aktuálna"
                                value={shelterData.usedCapacity}
                                helperText="Kapacita"
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <TextField
                                fullWidth
                                required
                                type="number"
                                id="capacity"
                                name="capacity"
                                label="Maximálna"
                                value={shelterData.capacity}
                                helperText="Kapacita"
                                onChange={handleInputChange}
                            />
                        </Grid>

                        <Grid item xs={12} className={"group-heading"}>
                            <h3 className={"margin-zero"}>Fotky zariadenia</h3>
                        </Grid>
                        {
                            shelterData.images.map((el, index) =>{
                                return(
                                    <Grid item className={"single-item"} xs={12} key={index}>
                                        <TextField
                                            fullWidth
                                            required
                                            id={`images-${index}`}
                                            name={`images-${index}`}
                                            label="Link na fotku zariadenia"
                                            value={el}
                                            onChange={handleArrayChange}
                                        />
                                    </Grid>
                                )
                            })
                        }
                        <Grid item xs={2} className={"array-button"}>
                            <Button onClick={() => addToArray("images")}>Pridaj</Button>
                        </Grid>

                        <Grid item xs={2} className={"array-button"}>
                            <Button onClick={() => popFromArray("images")}>Odober</Button>
                        </Grid>

                        <Grid item xs={12} className={"group-heading"}>
                            <h3 className={"margin-zero"}>Pravidlá</h3>
                        </Grid>
                        {
                            shelterData.rules.map((el, index) =>{
                                    return(
                                        <Grid item className={"single-item"} xs={12} key={index}>
                                            <TextField
                                                fullWidth
                                                required
                                                multiline
                                                id={`rules-${index}`}
                                                name={`rules-${index}`}
                                                label="Pravidlo"
                                                value={el}
                                                onChange={handleArrayChange}
                                            />
                                        </Grid>
                                    )
                            })
                        }
                        <Grid item xs={2} className={"array-button"}>
                            <Button onClick={() => addToArray("rules")}>Pridaj</Button>
                        </Grid>

                        <Grid item xs={2} className={"array-button"}>
                            <Button onClick={() => popFromArray("rules")}>Odober</Button>
                        </Grid>

                        <Grid item xs={12} className={"group-heading"}>
                            <h3 className={"margin-zero"}>Služby</h3>
                        </Grid>

                        {
                            shelterData.services.map((el, index) =>{
                                return(
                                    <Grid item className={"single-item"} xs={12} key={index}>
                                        <TextField
                                            fullWidth
                                            required
                                            multiline
                                            id={`services-${index}`}
                                            name={`services-${index}`}
                                            label="Služba"
                                            value={el}
                                            onChange={handleArrayChange}
                                        />
                                    </Grid>
                                )
                            })
                        }
                        <Grid item xs={2} className={"array-button"}>
                            <Button onClick={() => addToArray("services")}>Pridaj</Button>
                        </Grid>

                        <Grid item xs={2} className={"array-button"}>
                            <Button onClick={() => popFromArray("services")}>Odober</Button>
                        </Grid>

                        <Grid item xs={12} className={"group-heading"}>
                            <h3 className={"margin-zero"}>Cenník</h3>
                        </Grid>

                        {
                            shelterData.priceList.map((el, index) =>{
                                return(
                                  <Grid item xs={12} className={"single-item price-margin"} key={index}>
                                      <Grid spacing={4} container>
                                          <Grid item xs={12} md={10}>
                                              <TextField
                                                  fullWidth
                                                  required
                                                  multiline
                                                  id={`priceList-${index}-service`}
                                                  name={`priceList-${index}-service`}
                                                  maxRows={1}
                                                  label="Služba"
                                                  value={el.service}
                                                  onChange={handleArrayObjectChange}
                                              />
                                          </Grid>
                                          <Grid item xs={12} md={2}>
                                              <TextField
                                                  fullWidth
                                                  required
                                                  type="number"
                                                  inputProps={{
                                                      step: "0.01"
                                                  }}
                                                  id={`priceList-${index}-price`}
                                                  name={`priceList-${index}-price`}
                                                  label="Cena"
                                                  value={el.price}
                                                  onChange={handleArrayObjectChange}
                                              />
                                          </Grid>
                                      </Grid>
                                  </Grid>
                                )
                            })
                        }
                        <Grid item xs={2} className={"array-button"}>
                            <Button onClick={() => addToArray("priceList")}>Pridaj</Button>
                        </Grid>

                        <Grid item xs={2} className={"array-button"}>
                            <Button onClick={() => popFromArray("priceList")}>Odober</Button>
                        </Grid>

                        <Grid item xs={12}>
                            <Button type="submit" variant="contained">{id === "new" ? "Pridať" : "Upraviť"}</Button>
                        </Grid>
                        {
                            id !== "new" &&
                            <Grid item xs={12}>
                                <Button variant="contained" color='error' onClick={deleteThisDoc}>Vymazať</Button>
                            </Grid>
                        }
                    </Grid>
                </form>
            </Container>
        )
    );
}

export default Shelter;
